module.exports = __webpack_public_path__ + "img/logo_cropped.b4530a1f.png";